<template>
  <div v-if="!load" class="d-flex justify-center align-center ">
    <semipolar-spinner
        :animation-duration="2000"
        :size="115"
        color="#1935ff"
    />
  </div>
  <v-card v-else class="subtitle-1 text-left" flat>
    <v-card-title class="display-1 subprimary">
      <v-btn
          @click="returnParent()" class="  black--text" icon small>
        <v-icon>arrow_back</v-icon>
      </v-btn>
      {{ detail.lastname }} {{ detail.firstname }} {{ detail.midname }}
      <v-icon>{{returnIcon()}}</v-icon>
    </v-card-title>
    <v-row justify="center" style="height: calc(100vh - 110px); min-height: 420px">
      <v-col md="auto" sm="12" class="d-flex">
        <div class="my-auto" style="width: 100%;">
          <v-card-text class="headline"> {{ detail.event.name }}</v-card-text>
          <v-row no-gutters>
            <v-col>
              <v-card-text class="py-1">Почта: <b> {{ detail.email }} </b> </v-card-text>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-card-text class="py-1">Посещение: <b>{{ formatDate(detail.day, 'DD.MM.YYYY') }} {{ detail.interval.started }}</b></v-card-text>
            </v-col>
          </v-row>
          <v-card-text>
          <v-row v-if="!detail.canceled && !detail.is_visited">
              <v-col  >
                <v-btn color="yellow"  @click="canceledToken()" width="100%">Отменить запись</v-btn>
              </v-col>

          </v-row>
          </v-card-text>
        </div>
      </v-col>

      <v-col md="auto" sm="12" class="align-center justify-center; d-flex">
        <div class="my-auto">
          <qrcode :value="createQRcode()" :options="{ width: 400 }"></qrcode>
        </div>
      </v-col>

    </v-row>
    <v-alert v-if=error type="error" class="ma-0" style="position: absolute; width: 100%; bottom: 0" dismissible>
      {{String(error)}}
    </v-alert>
  </v-card>
</template>

<script>
import urls from "@/urls/helper";
import {loadData,sendPostRequest,sendDeleteRequest} from "@/helper/requests";
import imgCart from "@/assets/fone.jpg"
import {SemipolarSpinner} from "epic-spinners";
import names from "@/modules/recording/routers/names";
import moment from "moment";
import {isAuthenticated} from "@/helper";

export default {
  name: "Category",
  components: {
    SemipolarSpinner
  },

  computed: {
  },

  data() {
    return {
      imgCart: imgCart,
      errLoad: false,
      load: false,
      detail: {},
      error:null
    }
  },
  methods: {
    formatDate(date, format){
      return moment(date).format(format)
    },
    returnIcon(){
      if(this.detail.is_visited){
        return "done_all"
      }
      if(this.detail.canceled){
        return "clear"
      }
      return "hourglass_empty"
    },
    returnParent() {
      if (isAuthenticated()) {
        this.$router.push({name: names.PUBLIC.MYEVENTS})
      }else {
        this.$router.push({name: names.BASE})
      }
    },
    canceledToken(){
      let data ={}
      this.error = null
      sendDeleteRequest( urls.getRecordingUrlWithParameters('token|event|records-detail', 'destroy', {token: this.detail.code }),
          (json)=>{
            this.load = false
            this.loadDetail()
          },
          (json)=>{
            this.error = json.error
          }
      )
    },

    loadDetail(){
      loadData(
          urls.getRecordingUrlWithParameters('token|event|records-detail', 'retrieve', {token: this.$route.params.code}),
          (data) => {
            this.detail = data
            this.load = true
          },(json)=>{
            this.$router.push({name: names.BASE})
          }
      )
    },

    createQRcode() {
      return window.location.origin + this.$router.resolve({name: names.ADMINEVENTS.TOKEN,params:{event: this.detail.id, token:this.detail.code}}).href
    },
  },

  created() {
    // this.date = new Date().toISOString().slice(0, 10)
    this.loadDetail()
  }
}
</script>

<style scoped>

</style>
